import React from 'react';
import discord from '../assets/discord.png';
import twitter from '../assets/twitter.png';
import gmail from '../assets/gmail.png';
import { Bounce } from 'react-reveal';

function Typewriter({ text, speed }) {
  const [typedText, setTypedText] = React.useState('');
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (index < text.length) {
        setTypedText(prevText => prevText + text.charAt(index));
        setIndex(prevIndex => prevIndex + 1);
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [index, text, speed]);

  return (
    <h4 className='text-sm lg:text-lg lg:py-2 px-5 text-center lg:px-[27%] lg:pb-5'>
      {typedText}
    </h4>
  );
}

function Socials() {
  return (
    <div className='lg:py-[3%] py-[6%] bg-gray mx-[5%]'>
        <div className='flex flex-col items-center justify-center'>
            <h1 className='text-2xl lg:text-4xl'>Build With Us</h1>
            <Typewriter text="Join our community of enthusiasts in the Web3 Space!!!" speed={100} />
        </div>
        <div className='flex items-center justify-center flex-wrap px-[5%] lg:px-[10%]'>
            <Bounce>
              <a className='md:w-[50%] w-[100%]' href='https://discord.com/invite/AfeQfaxJuF'>
               <div className='flex items-center justify-between py-3 px-5 lg:py-5 lg:px-7 border-2 border-[#2f59bc17] shadow-lg shadow-[ 0px 17px 36px rgba(0, 0, 0, 0.02)] rounded-xl my-3 lg:my-7 mx-5'>
                <div className='text-left flex flex-col items-start pr-[6%]'>
                    <h4 className='text-base lg:text-2xl font-medium text-black'>DISCORD</h4>
                    <h5 className='text-xs lg:text-sm font-medium text-[#98A2B3]'>New information and updates</h5>
                </div>
                <div>
                    <img className='w-[70%] lg:w-[100%]' src={discord} alt="discord logo" />
                </div>
            </div> 
            </a>
            </Bounce>
            <Bounce>
              <a className='md:w-[50%] w-[100%]' href='https://twitter.com/WalkersDao'>
               <div className='flex items-center justify-between py-3 px-5  lg:py-5 lg:px-7 border-2 border-[#2f59bc17] shadow-lg shadow-[ 0px 17px 36px rgba(0, 0, 0, 0.02)] rounded-xl my-3 lg:my-7 mx-5'>
                <div className='text-left flex flex-col items-start pr-[6%]'>
                    <h4 className='text-base lg:text-2xl font-medium text-black'>TWITTER</h4>
                    <h5 className='text-xs lg:text-sm font-medium text-[#98A2B3]'>Keep up with new trends</h5>
                </div>
                <div>
                    <img className='w-[60%] lg:w-[90%]' src={twitter} alt="discord logo" />
                </div>
            </div> 
            </a>
            </Bounce>
            <Bounce>
              <a className='md:w-[50%] w-[100%] ' href="mailto:walkersdao1@gmail.com">
               <div className='flex items-center justify-between py-3 px-5  lg:py-5 lg:px-7 border-2 border-[#2f59bc17] shadow-lg shadow-[ 0px 17px 36px rgba(0, 0, 0, 0.02)] rounded-xl my-3 lg:my-7 mx-5'>
                <div className='text-left flex flex-col items-start pr-[6%]'>
                    <h4 className='text-base lg:text-2xl font-medium text-black'>EMAIL</h4>
                    <h5 className='text-xs lg:text-sm font-medium text-[#98A2B3]'>Want to collaborate? send mail</h5>
                </div>
                <div>
                    <img className='w-[70%] lg:w-[100%]' src={gmail} alt="discord logo" />
                </div>
            </div> 
            </a>
            </Bounce>
        </div>
    </div>
  )
}

export default Socials;
